module.exports = __webpack_public_path__ + "img/userWalletTransactions.cbc99471.svg";